(()=>{
  const setup=(root=document)=>root.querySelectorAll('.pw-slide__media video').forEach(video=>{
    if(video.dataset.pwVideoReady)return;
    video.dataset.pwVideoReady='true';
    const playing=()=>video.classList.add('is-playing');
    const stopped=()=>video.classList.remove('is-playing');
    video.addEventListener('playing',playing);
    video.addEventListener('pause',stopped);
    video.addEventListener('error',stopped);
    if(!video.paused&&video.readyState>=2)playing();
    video.muted=true;
    video.play().catch(stopped);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
  document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
